import { Box, Card, styled, useTheme } from '@mui/material';
import { H3 } from 'components/Typography';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import FlexRowAlign from 'components/flexbox/FlexRowAlign';
import {
  Book,
  Bookmark,
  CircleDollarSign,
  Edit3,
  MessageCircle,
  PenLine,
  Sparkles,
  SquarePen,
  User,
} from 'lucide-react';
import MyPostItem from './MyPostItem';

const MyPostCard = ({
  isTablet,
  isMobile,
  postsData = [],
  title = '내 댓글에 답글',
  icon = MessageCircle,
  count = '999+',
  navigationRoute,
  filterItems = ['전체', '자유게시판', '질문답변', '정보공유', '후기', '모임'],
  onCardClick,
  showAIRecommendButton = false,
  ...props
}) => {
  const navigate = useNavigate();
  const theme = useTheme();

  const handleCardClick = item => {
    if (onCardClick) {
      onCardClick(item);
    } else {
      navigate(navigationRoute);
    }
  };

  const handleViewAllClick = () => {
    if (navigationRoute) {
      navigate(navigationRoute);
    }
  };

  // Get icon component from string name or use passed component
  const getIconComponent = () => {
    if (typeof icon === 'string') {
      const iconMap = {
        MessageCircle: MessageCircle,
        Bookmark: Bookmark,
        Edit3: Edit3,
        User: User,
        Sparkles: Sparkles,
        CircleDollarSign: CircleDollarSign,
        Book: Book,
        SquarePen: SquarePen,
        PenLine: PenLine,
      };
      return iconMap[icon] || MessageCircle;
    }
    return icon;
  };

  const dataToUse = postsData;

  let padding;
  if (window.innerWidth > 1720 && !isTablet) {
    padding = '0px 0px';
  } else {
    padding = isTablet ? '0px 15px' : '0px 0px';
  }

  const StyledCard = styled(Card)(({ theme }) => ({
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    padding: padding,
    backgroundColor: 'transparent',
    borderRadius: 0,
    border: 'none',
    [theme.breakpoints.down('sm')]: {
      '& > .MuiBox-root': {
        paddingBottom: 0,
      },
    },
  }));

  return (
    <StyledCard
      sx={{
        border: 'none',
        overflow: 'visible',
        ...props.sx,
      }}
    >
      <Box
        sx={{
          width: '100%',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {/* Header */}
        <Box
          sx={{
            backgroundColor: '#fff',
            padding: isMobile ? '18px' : '26px',
            borderRadius: '24px',
            boxShadow: '1px 4px 6px rgba(0, 0, 0, 0.05)',
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            mb={1}
          >
            <FlexRowAlign mb={2} justifyContent="space-between" width="100%">
              <FlexRowAlign>
                <Box
                  sx={{
                    marginRight: '8px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {React.createElement(getIconComponent(), {
                    size: 24,
                    color: theme.palette.primary.main,
                  })}
                </Box>
                <H3>{title}</H3>
                {count !== '0' && count !== 0 && (
                  <Box
                    sx={{
                      backgroundColor: theme.palette.primary.mainBlue,
                      color: theme.palette.primary.white,
                      padding: isMobile ? '2px 8px' : '3px 10px',
                      borderRadius: '100px',
                      fontSize: isMobile ? '12px' : '12px',
                      fontWeight: '600',
                      display: 'inline-block',
                      marginLeft: '8px',
                      minWidth: 'auto',
                    }}
                  >
                    {count}
                  </Box>
                )}
              </FlexRowAlign>
            </FlexRowAlign>
          </Box>

          {/* 마이페이지 댓글 카드 */}
          <Box
            mb={0}
            sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}
          >
            {dataToUse.slice(0, 5).map((item, index) => (
              <MyPostItem
                key={item.id}
                item={item}
                isMobile={isMobile}
                onClick={handleCardClick}
              />
            ))}
          </Box>
        </Box>
      </Box>
    </StyledCard>
  );
};

export default MyPostCard;
